import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { CheckSquare, HelpCircle, Bell, CalendarClock, UserPlus } from 'lucide-react';
import KPICard from '../components/dashboard/KPICard';
import { getReceptionistKpiData } from '../data/mockData';
import MemberRegistrationWizard from '../components/registration/MemberRegistrationWizard';
import api from '../services/ApiService';
import { ENDPOINTS } from '../constant/ApiEndpoints';
import toast from 'react-hot-toast';
import useDidFetch from '../custom_hooks/useDidfetch';
import { ROLES } from '../constant/roles';
import { cleanObject } from '../components/CleanObject';

const ReceptionistDashboard = () => {
    const [kpiData, setKpiData] = useState(getReceptionistKpiData());
    const [ReceptionistDashboardData, setReceptionistDashboardData] = useState({});
    const [isWizardOpen, setIsWizardOpen] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false); 
    const [count, setCount] = useState({
        "todays_checkin": 0,
        "new_enquiries": 0,
        "pending_followups": 0,
        // "upcoming_renewl" :0
    })
    const navigate = useNavigate();

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };
    const runOnce = useDidFetch();
    useEffect(() => {
        runOnce(() => {
            getAllUsers();
            getReceptionistDashboardData();
            // getAllPayments();

        })
    }, []);

    const getReceptionistDashboardData = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(`${ENDPOINTS.ReceptionistDashboardApi}`);
            const result = response?.data;
                console.log(response);
            if (response.status === 200) { 
                setReceptionistDashboardData(result ?? {})
            }
        } catch (error) {
        } finally {
            // setIsLoading(false);
        }
    }

    const getAllUsers = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(`${ENDPOINTS.getUser}`);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                let allusers = result?.users ?? [];
                let trainers = allusers.filter((user) => user.role?.name == ROLES.TRAINER && user?.status == 'active');
                let members = allusers.filter((user) => user.role?.name == ROLES.MEMBER);
                setCount(prev => ({ ...prev, total_members: members.length, active_trainer: trainers.length }))
            }
        } catch (error) {
            console.error("user get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
    // const calculateEndDate = (start, plan) => {
    //     if (!start || !plan) return;

    //     const startObj = new Date(start);
    //     let endObj = new Date(startObj);

    //     console.log("endObj ===" + plan.access_type, endObj);
    //     if (plan.access_type === "month") {
    //         console.log("access_type ===" + plan.access_type, endObj.getMonth() + plan.duration);
    //         endObj.setMonth(endObj.getMonth() + plan.duration);

    //         const formatted = endObj.toISOString().split("T")[0];
    //         setEndDate(formatted);
    //     } else if (plan.access_type === "session") {
    //         endObj = startObj;
    //         setEndDate('');
    //         return;
    //     }

    // };
    const handleRegistrationSuccess = async (newMember) => {
        console.log("New member registered:", newMember); 
        let trainerId = parseInt(newMember?.membership?.assignedTrainer);
        let plan_id = parseInt(newMember?.membership?.planId);

        let obj = {
            //personal
            "name": newMember?.personal?.name,
            "email": newMember?.personal?.email,
            "phone": newMember?.personal?.contact,
            "dob": newMember?.personal?.dob,
            "gender": newMember?.personal?.gender,
            "emergency_contact_name": newMember?.personal?.emergencyContactName,
            "emergency_contact_number": newMember?.personal?.emergencyContactPhone,
            "address": newMember?.personal?.address,
            //health
            "height_cm": newMember?.health?.height,
            "weight_kg": newMember?.health?.weight,
            "fitness_level": newMember?.health?.level,
            "medical_conditions": newMember?.health?.conditions,
            "fitness_goals": newMember?.health?.goals,
            //membership
            "role_id": 3,
            "role": 3,
            "trainer_assigned": trainerId,
            "plan_id": plan_id,
            "image_base64": newMember?.personal?.base64Img,
            "start_date" : newMember?.membership?.startDate,
            "end_date": newMember?.membership?.endDate, 
            "status" : newMember?.membership?.userStatus
        } 
        let cleanData = cleanObject(obj);
        try {
            setSaveLoading(true);
            const response = await api.post(ENDPOINTS.saveUser, cleanData);
            const result = response?.data;
            console.log(response);
            if (response?.status == 200 || response?.status == 201) {
                toast.success(result?.message ?? "Member added Successfully"); 
                setIsWizardOpen(false);
                navigate(`/receptionist/members/`);
            } 
        } catch (error) {
            console.log("new member registration", error);
        } finally {
            setSaveLoading(false);
        }
    };

    return (
        <>
            <motion.div
                variants={containerVariants}
                initial="hidden"
                animate="visible"
                className="space-y-8"
            >
                <h1 className="text-3xl font-bold font-display text-gray-800">Receptionist Dashboard</h1>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    <KPICard title="Today's Check-ins" value={ReceptionistDashboardData.todays_attendance} icon={CheckSquare} change="+10%" changeType="increase" color="blue" />
                    <KPICard title="New Enquiries" value={ReceptionistDashboardData.todays_new_enquiries} icon={HelpCircle} change="+3" changeType="increase" color="green" />
                    <KPICard title="Pending Follow-ups" value={ReceptionistDashboardData.todays_pending_followups} icon={Bell} change="+5" changeType="increase" color="orange" />
                    {/* <KPICard title="Upcoming Renewals" value={kpiData.upcomingRenewals} icon={CalendarClock} change="-1" changeType="decrease" color="red" /> */}
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
                    <h3 className="text-lg font-bold text-gray-800 font-display">Quick Actions</h3>
                    <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-4">
                        <button onClick={() => navigate('/receptionist/check-in')} className="flex flex-col items-center justify-center p-4 bg-gray-100 rounded-lg text-center hover:bg-gray-200 transition-colors">
                            <CheckSquare className="w-8 h-8 mb-2 text-blue-500" />
                            <p className="font-semibold text-gray-700">Member Check-in</p>
                        </button>
                        <button onClick={() => navigate('/receptionist/enquiries')} className="flex flex-col items-center justify-center p-4 bg-gray-100 rounded-lg text-center hover:bg-gray-200 transition-colors">
                            <HelpCircle className="w-8 h-8 mb-2 text-green-500" />
                            <p className="font-semibold text-gray-700">Add Enquiry</p>
                        </button>
                        <button onClick={() => setIsWizardOpen(true)} className="flex flex-col items-center justify-center p-4 bg-gray-100 rounded-lg text-center hover:bg-gray-200 transition-colors">
                            <UserPlus className="w-8 h-8 mb-2 text-brand-red" />
                            <p className="font-semibold text-gray-700">Register Member</p>
                        </button>
                        <button onClick={() => navigate('/receptionist/schedule')} className="flex flex-col items-center justify-center p-4 bg-gray-100 rounded-lg text-center hover:bg-gray-200 transition-colors">
                            <CalendarClock className="w-8 h-8 mb-2 text-orange-500" />
                            <p className="font-semibold text-gray-700">View Schedule</p>
                        </button>
                    </div>
                </div>
            </motion.div>
            <MemberRegistrationWizard
                confirmBtnLoading={saveLoading}
                isOpen={isWizardOpen}
                onClose={() => setIsWizardOpen(false)}
                onSuccess={handleRegistrationSuccess}
            />
        </>
    );
};

export default ReceptionistDashboard;
